import FroalaEditor from 'froala-editor'

const buttons = [
  'bold',
  'italic',
  'underline',
  '|',
  'alignLeft',
  'alignCenter',
  'alignRight',
  'alignJustify',
  '|',
  'textColor',
  'backgroundColor',
  '|',
  'formatUL',
  'formatOL',
  '|',
  'insertDynamicVariables'
]

const moreMisc = {
  buttons: ['undo', 'redo', 'html'],
  align: 'right',
  buttonsVisible: 0
}

const config = {
  enter: FroalaEditor.ENTER_BR,
  fontSize: ['6', '7', '8', '9', '10', '11', '12', '14', '18', '24', '30', '36', '48', '60', '72', '96'],
  fontSizeUnit: 'pt',
  zIndex: 999999,
  heightMin: 100,
  toolbarButtonsXS: {
    moreText: {
      buttons,
      buttonsVisible: 0,
    }
  },
  toolbarButtonsSM: {
    moreText: {
      buttons,
      buttonsVisible: 4,
    }
  },
  toolbarButtonsMD: {
    moreText: {
      buttons,
      buttonsVisible: 5,
    }
  },
  toolbarButtons: {
    moreText: {
      buttons,
      buttonsVisible: 12
    },
    moreMisc
  },
  htmlAllowedStyleProps: ['font-size', 'background', 'color', 'text-align', 'vertical-align', 'background-color'],
  pastePlain: false,
  imagePaste: false,
  pasteDeniedTags: ['div', 'span', 'p'],
  pasteDeniedAttrs: ['class', 'id'],
  htmlAllowComments: false,
  imageUpload: false,
  events: {
    'paste.afterCleanup': (content: string): string => {
      return content.replaceAll(/<br([^>])+?>/gi, '<br>')
        .replaceAll(/font-size: ?([\d.]+)px/gi, 'font-size: $1pt')
    }
  }
}

export default config
